import { render, staticRenderFns } from "./StackedRow.vue?vue&type=template&id=51cc2c6a&scoped=true&"
import script from "./StackedRow.vue?vue&type=script&lang=js&"
export * from "./StackedRow.vue?vue&type=script&lang=js&"
import style0 from "./StackedRow.vue?vue&type=style&index=0&id=51cc2c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc2c6a",
  null
  
)

export default component.exports